import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { TableCell, TableRow } from 'transfix-ui/components/Table'
import { IEdiMessage } from 'types/graphqlTypes'
import DISPLAY from 'constants/display'
import { ActiveStatus } from '../../ActiveStatus'
import { ParserVersion } from '../../EdiSelfService/types'
import { decodeOptionValue } from '../../EdiSelfServiceOutbound/hooks/useTransactionSets'
import { EDI_TOOLS_ROUTES } from '../../LandingPage'
import { INBOUND_TAB } from '../constants'
import { useGetCurrentParser } from '../hooks/useGetCurrentParser'
import { useGetCurrentParserVersion } from '../hooks/useGetCurrentParserVersion'
import { formatConnectionConfigName, formattedEdiMessageType } from '../utils'

interface IShipperConfigInboundRowProps {
  ediMessageType: IEdiMessage
  onlyShowActive: boolean
  selectedTransactionSet: string
}

export const ShipperConfigInboundRow = ({
  ediMessageType,
  onlyShowActive,
  selectedTransactionSet,
}: IShipperConfigInboundRowProps) => {
  const { id, name } = useParams<{ id: string; name: string }>()

  const isActive = (parserVersion: ParserVersion | undefined) => {
    if (ediMessageType.ediMapperConfigurableParserId) {
      return parserVersion?.is_live && !ediMessageType.ediMapperConnectionConfig?.disabled
    }
    return !ediMessageType.ediMapperConnectionConfig?.disabled
  }

  const parser = useGetCurrentParser(ediMessageType.ediMapperConfigurableParserId)
  const parserVersion = useGetCurrentParserVersion(parser)
  const ediMapper = 'Edi Mapper'
  const parserName = parser?.name || ediMessageType.legacyParserClass || ediMapper
  const parserLinkEnabled = parserName === parser?.name
  const isMessageTypeActive = isActive(parserVersion)
  const decodedTransactionSet = decodeOptionValue(selectedTransactionSet)
  const subtypeMatches =
    ediMessageType.transactionSetSubtype === (decodedTransactionSet.transactionSetSubtype || null)
  const matchesTransactionSetFilter =
    (ediMessageType.transactionSet === decodedTransactionSet.transactionSet && subtypeMatches) ||
    selectedTransactionSet === 'none'

  return (
    <>
      {(onlyShowActive && !isMessageTypeActive) || !matchesTransactionSetFilter ? (
        <></>
      ) : (
        <TableRow>
          <TableCell dataTest='connection-config'>
            <Link
              to={`${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/${id}/shipperName/${name}/inboundConfigId/${ediMessageType?.ediMapperConnectionConfig?.id}?tab=${INBOUND_TAB}`}>
              {formatConnectionConfigName(ediMessageType?.ediMapperConnectionConfig)}
            </Link>
          </TableCell>
          <TableCell dataTest='config-live'>
            <ActiveStatus disabled={ediMessageType?.ediMapperConnectionConfig?.disabled} />
          </TableCell>
          <TableCell dataTest='file-type'>{formattedEdiMessageType(ediMessageType)}</TableCell>
          <TableCell dataTest='parser'>{parserName}</TableCell>
          <TableCell dataTest='parser-live'>
            {parserLinkEnabled && <ActiveStatus disabled={!parserVersion?.is_live} />}
          </TableCell>
          <TableCell dataTest='parser-version'>
            {parserLinkEnabled ? (
              <Link
                to={`${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/${id}/shipperName/${name}/parserId/${ediMessageType.ediMapperConfigurableParserId}?tab=${INBOUND_TAB}`}>
                {parserVersion?.id}
              </Link>
            ) : (
              DISPLAY.empty
            )}
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

export default ShipperConfigInboundRow
